import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-seller-activity-tab',
  templateUrl: './seller-activity-tab.component.html',
  styleUrls: ['./seller-activity-tab.component.scss']
})
export class SellerActivityTabComponent {
  @Input() viewChallengeFlag = 1;
}
